import { MantineColorScheme } from '@mantine/core';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Algorithm } from './models.ts';

export interface State {
  colorScheme: MantineColorScheme;

  idToken: string;
  round: string;

  /**
   * When true, activity-log rows with an empty / invalid book (no bids & asks or mid = 0)
   * are omitted from price / order-book charts so lines do not dive to zero between sessions.
   */
  hideEmptyOrderBookTicks: boolean;

  algorithm: Algorithm | null;

  setColorScheme: (colorScheme: MantineColorScheme) => void;
  setIdToken: (idToken: string) => void;
  setRound: (round: string) => void;
  setHideEmptyOrderBookTicks: (hide: boolean) => void;
  setAlgorithm: (algorithm: Algorithm | null) => void;
}

export const useStore = create<State>()(
  persist(
    set => ({
      colorScheme: 'auto',

      idToken: '',
      round: 'ROUND0',

      hideEmptyOrderBookTicks: false,

      algorithm: null,

      setColorScheme: colorScheme => set({ colorScheme }),
      setIdToken: idToken => set({ idToken }),
      setRound: round => set({ round }),
      setHideEmptyOrderBookTicks: hideEmptyOrderBookTicks => set({ hideEmptyOrderBookTicks }),
      setAlgorithm: algorithm => set({ algorithm }),
    }),
    {
      name: 'imc-prosperity-4-visualizer',
      partialize: state => ({
        colorScheme: state.colorScheme,
        idToken: state.idToken,
        round: state.round,
        hideEmptyOrderBookTicks: state.hideEmptyOrderBookTicks,
      }),
    },
  ),
);
